var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissedCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Missed_Calls"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Missed_Calls",
    clipPath: "url(#clip-Missed_Calls)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(-6.327 -4.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M12.818,0,6.954,5.864,2.635,1.545H6.181V0H0V6.181H1.545V2.635L6.954,8.043l6.954-6.954Z",
    transform: "translate(14.051 11.263) rotate(-7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Call_copy",
    "data-name": "Call copy",
    d: "M0,4.73S.68,15.57,10.01,19.278a5.07,5.07,0,0,0,5.966-1.772s.477-1.059-.918-2.168L12.545,13.4a1.111,1.111,0,0,0-1.265.031L9.8,14.584s-.411.521-1.38-.066A15.639,15.639,0,0,1,4.072,7.961.946.946,0,0,1,4.6,6.983L5.8,6.1s.723-.374.412-1.629L5.573,1.2A1.838,1.838,0,0,0,2.863.316S.414,1.161,0,4.73Z",
    transform: "translate(34.136 25.018) rotate(125)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissedCalls);
export default __webpack_public_path__ + "static/media/Missed_Calls.90e17ae189fec83857fbf4de3bf2ad34.svg";
export { ForwardRef as ReactComponent };